import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';

// Alley tooltip
const tooltips = document.querySelectorAll("[data-component='tooltip']");

if (tooltips.length ) {
	tooltips.forEach((tooltip) => {
		const tip = tooltip.querySelector("[data-tooltip-tip]");
		tip.style.right = `-${tip.offsetWidth / 2 - 10}px`;
	});
}

// Tippy Tooltips
// https://atomiks.github.io/tippyjs/
// Here's how to effortlessly bring your tooltips to life:
// simply add your content to the "data-tippy-content" attribute
// right on the trigger element. Magic awaits! 🚀

tippy('[data-tippy-content]', {
    allowHTML: true, // Allows HTML content inside the tooltip
    interactive: true, // Makes the tooltip interactive
    theme: 'light',
    animation: 'shift-toward',
    arrow: true,
    maxWidth: 'none',
});
